import React, { useState } from "react";

const InputRemainders = () => {
	const [percentage, setPercentage] = useState("0");

	return (
		<>
			<div className="remainders">
				<button
					className={percentage === "25%" && "active"}
					onClick={() => setPercentage("25%")}
				>
					<span>25%</span>
				</button>
				<button
					className={percentage === "50%" && "active"}
					onClick={() => setPercentage("50%")}
				>
					<span>50%</span>
				</button>
				<button
					className={percentage === "75%" && "active"}
					onClick={() => setPercentage("75%")}
				>
					<span>75%</span>
				</button>
				<button
					className={percentage === "100%" && "active"}
					onClick={() => setPercentage("100%")}
				>
					<span>100%</span>
				</button>
			</div>
		</>
	);
};

export default InputRemainders;
